import { Link } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import { UNDELETE_MESSAGE } from "../../common/Constant";
import { toastSuccess } from "../../common/Toast";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";

const ActiveConfirmation = ({ deleteApiUrl, open, onClose }) => {
  function handleSubmit() {
    const token = localStorage.getItem("Token");
    const deleteRequestParam = localStorage.getItem("DeleteRequestParam");
    axios
      .post(`${deleteApiUrl}`, deleteRequestParam, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then(() => {
        toastSuccess(UNDELETE_MESSAGE);
        window.location.reload();
      });
  }

  return (
    <>
      <Dialog open={open}>
        <DialogTitle textAlign="center">Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to Active this records?
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button class="btn btn-sm btn-outline-dark" onClick={onClose}>
            Cancel
          </Button>
          <Button
            class="btn btn-sm btn-primary"
            onClick={handleSubmit}
            variant="contained"
          >
            Active
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ActiveConfirmation;
